import {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog26/image3 Golden cross performance.png";
import image2 from "../../../../assets/images/Blog26/image26 R2K catch up.png";
import image3 from "../../../../assets/images/Blog26/image5 NAAIM.png";
import image4 from "../../../../assets/images/Blog26/image34 SPX bulls.png";
import image5 from "../../../../assets/images/Blog26/image64 Trump July9th ideas.png";
import image6 from "../../../../assets/images/Blog26/image69 Sintra Panel.png";
import image7 from "../../../../assets/images/Blog26/image17 Fergusons law.png";
import image8 from "../../../../assets/images/Blog26/image10 $ not reacting to rates or stresses.png";
import image9 from "../../../../assets/images/Blog26/image12 dollar reserves into gold.png";
import image10 from "../../../../assets/images/Blog26/image1 VIX.png";
import image11 from "../../../../assets/images/Blog26/image4 F&G.png";
import image12 from "../../../../assets/images/Blog26/image7 Mon max pain.png";
import image13 from "../../../../assets/images/Blog26/image13.png";
import image14 from "../../../../assets/images/Blog26/image25 SPX v breadth.png";
import image15 from "../../../../assets/images/Blog26/image63 SPX 2W seasonality.png";
import image16 from "../../../../assets/images/Blog26/image32 ATH 26-59 rule.png";
import image17 from "../../../../assets/images/Blog26/image27 3rd longest no ATH streak for R2k.png";
import image18 from "../../../../assets/images/Blog26/image40 NFP v ADP nonsense.png";
import image19 from "../../../../assets/images/Blog26/image42 NFP sectors.png";
import image20 from "../../../../assets/images/Blog26/image55 Gold monthly consol (1).png";
import image21 from "../../../../assets/images/Blog26/image56 oil from bulltobear.png";
import image22 from "../../../../assets/images/Blog26/image59 BTC Treasuries flying.png";
import image23 from "../../../../assets/images/Blog26/image44 big events ahead.png";

const Blog26 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – July 7th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Trump’s Tariff Game, Rate Cut Chess, and a Market That Won’t Quit</p>
        <p>
          Markets continue to rise as political theatre, global deflation fears, and dovish central bank signals fuel risk appetite. Behind the headlines, structural forces are shifting: Trump’s trade
          tactics, Powell’s balancing act, and the dollar’s mysterious drift all converge in this pivotal week. Here’s your full macro breakdown, technical map, and trading forecast.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: ATHs Hold, Rotation Broadens, but Risks Linger</p>
              <p>
                Markets continued their summer rally, shrugging off tariff anxiety and recession talk. The S&P 500 hit fresh all-time highs while{" "}
                <span className="highlightedText"> small caps joined the breakout,</span> suggesting this move isn’t just about mega-cap momentum anymore.
              </p>
              <p>Underneath, however, there’s reason for tactical caution:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">SPX has rallied +26% in just 59 days—</span> a rare historical feat
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">VIX and P/C ratios</span> show bullish complacency, but not extremes
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NAAIM exposure </span> sits just below 100, a common fade zone
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Participation breadth</span> is improving, but is still thin in places
                  </p>
                </li>
              </ul>
              <p>
                Liquidity and seasonality remain tailwinds, but we’re nearing zones where markets often consolidate. Traders looking for a deeper pullback may have to wait until earnings or CPI
                provide a catalyst.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Macro & Policy Watch: Tariff Poker, Deflation Fears, and Dollar Decoupling</p>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Trump’s Tariff Letters: The Clock Is Ticking
              </p>
              <p>
                July 9 marks Trump’s self-imposed deadline for sending reciprocal tariff letters. While a deal with Vietnam is sealed {""}
                <span className="highlightedText">EU and BRICs tensions are mounting </span>
                The market expects a delay (TACO), but the risk of an actual move could rattle complacent bulls.
              </p>
              <p>
                Trump’s rhetoric is all in: markets at highs, Powell under fire, and America “winning” on trade. Whether that narrative holds depends on how global partners respond. Aug 1st is tariff
                pay day
              </p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image5}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image5)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Powell’s Messaging: Dovish, But Cornered
              </p>
              <p>
                At Sintra, Powell admitted they would’ve cut already<span className="highlightedText"> if not for tariff uncertainty</span>. He acknowledged inflation is cooling and growth is solid.
                But politically, he’s under pressure. Trump has escalated attacks, positioning himself as the driver of both markets and monetary policy.
              </p>
              <p>
                Meanwhile, <span className="highlightedText"> global central banks</span> are turning openly dovish:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    ECB and BOE speakers now see the risk of <span className="highlightedText">inflation undershooting</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Swap spreads are deeply negative <span className="highlightedText">markets expect deflation</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>RBA and RBNZ decisions this week could reinforce the rate cut narrative</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                The Dollar: A Controlled Collapse?
              </p>
              <p>
                Despite leading global rates, the dollar can’t catch a bid. DXY has weakened steadily— <span className="highlightedText">a break in the rate-differential link.</span> Trump’s barrage
                on Powell may be working, with global reserve managers rebalancing toward gold and commodities.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold is consolidating</span> not selling off—a tell for underlying demand
                  </p>
                </li>
                <li className="themesPointer">
                  <p>EMFX and non-US assets benefit from DXY softness</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">The dollar is no longer a safe haven during stress </span>
                    that’s a major shift
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Breadth Improves, but Sentiment Stretches</p>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText"> Positioning Snapshot:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">VIX:</span> Multi-month lows, showing implied calm
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Put/Call Ratio:</span> Bullish skew (0.56), but not frothy
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gamma Landscape:</span> SPX 6300 call wall, Max Pain 6200—expect pinning near expiry
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fear & Greed Index:</span> firmly in “Greed” zone, but not manic
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The uptrend is intact, and sentiment isn’t at red-alert levels—but we’re certainly not early. This is classic melt-up territory, powered by{" "}
                <span className="highlightedText">under-positioning finally catching up.</span>
              </p>
            </div>

            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <p className="highlightedBoldText">Breadth Turning Up—Finally</p>
                <li className="themesPointer">
                  <p>Small caps and financials caught a bid last week</p>
                </li>
                <li className="themesPointer">
                  <p>Global equities (ACWI) broke resistance</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Participation breadth now rising, not fading</span>
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/*  */}

            <div className="contentDivWrapper flexDiv ">
              <div className="contentDiv">
                <p className="highlightedBoldText">Seasonality Remains a Bullish Anchor</p>
                <p>
                  July's first half is historically one of the strongest stretches of the year, and this year is playing to script. But note: after massive May/June gains,{" "}
                  <span className="highlightedText">July often introduces chop,</span>
                  especially post-CPI and into earnings season.
                </p>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        {/*  */}

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Last Week’s Recap: Strong Jobs, Soft Private Payrolls, and Steady Gold</p>
            </div>

            <div className="contentDiv listOfRecap">
              <p>The June NFP report came in hotter than expected—147k vs 95k whisper—but the quality of the beat was questioned.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Education and Health drove the print,</span> likely from seasonal adjustments
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Private payrolls and manufacturing jobs declined,</span> in line with weak ADP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Wages softened</span> to 3.7% YoY—lowest since July 2024
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Unemployment rate ticked down to 4.1%,</span> despite a shrinking labour force
                  </p>
                </li>
              </ul>
              <p>
                Net takeaway? The report was good enough to <span className="highlightedText">remove a July cut</span>, but not strong enough to derail the September pivot narrative
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p>Elsewhere:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold held firm,</span> supported by central bank demand and deflation fears
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil reversed lower,</span> with Trump waiting to refill the SPR at cheaper levels
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto broke out,</span> driven by institutional accumulation and tokenisation news
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Tariff Deadline, Global CPI, and Central Bank Crosscurrents</p>

              <p className="">While earnings season hasn’t officially kicked off, this week brings some macro fireworks.</p>
              <p className="highlightedText">Monday, July 7</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>UK Halifax House Prices</p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>US Treasury Bill Auctions</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, July 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">RBA Rate Decision </span>(cut expected)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>US NFIB Small Business Optimism</p>
                </li>
                <li className="themesPointer">
                  <p>NY Fed Consumer Inflation Expectations</p>
                </li>
                <li className="themesPointer">
                  <p>US Consumer Credit</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, July 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">Trump Tariff Letter Deadline</p>
                </li>
                <li className="themesPointer">
                  <p>China CPI/PPI</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">RBNZ Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Minutes</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, July 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US Initial & Continuing Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p>Italy Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>30Y Bond Auction</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, July 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>UK GDP</p>
                </li>
                <li className="themesPointer">
                  <p>German and French Final CPI</p>
                </li>
                <li className="themesPointer">
                  <p>Canadian Employment & Wages</p>
                </li>
                <li className="themesPointer">
                  <p>US Federal Budget Balance</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: The Bull Charges On, But Watch the Curveball</p>
            </div>
            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <p>The rally is real, but the risks are rising:</p>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Tariff volatility is unpriced</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Breadth is improving, but stretched sentiment could trigger air pockets</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Central banks are increasingly worried about deflation, not inflation</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dollar weakness is structural, not temporary</span>
                  </p>
                </li>
              </ul>
            </div>

            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <p>Our Stance:</p>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Stay long SPX above 6200</span> with tight stops
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Add on dips in Gold and Crypto—</span> safe havens with structural tailwinds
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Rotate into small caps and financials </span>
                    if breadth holds
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Be tactical around CPI, earnings, and the July 9 tariff deadline</span>
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom of blog */}

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1_2ZG8ixMU75u24aSOBc33g5nyOlVVIoMLsP6idEkkRk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog26;
